"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function ContactHero() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "end start"]
  });

  const y = useTransform(scrollYProgress, [0, 1], ["0%", "30%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);

  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] }
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  return (
    <section
      ref={sectionRef}
      className="pt-32 pb-12 relative overflow-hidden bg-dark-bg"
    >
      <motion.div 
        className="absolute inset-0 pointer-events-none" 
        style={{ 
          y, 
          opacity,
          background: "radial-gradient(ellipse 70% 60% at 50% 0%, rgba(75, 0, 130, 0.15) 0%, rgba(106, 13, 173, 0.1) 40%, transparent 70%)"
        }}
      />
      <motion.div 
        className="max-w-3xl mx-auto px-6 text-center relative z-10"
        variants={staggerContainer}
        initial="initial"
        animate="animate"
      >
        <motion.span variants={fadeInUp} className="section-label mb-6 inline-flex">Get In Touch</motion.span>
        <motion.h1
          variants={fadeInUp}
          className="font-heading font-extrabold text-text-primary mb-5"
          style={{ fontSize: "clamp(36px, 5vw, 60px)", letterSpacing: "-0.025em", lineHeight: "1.1" }}
        >
          Let's build your{" "}
          <span className="gradient-text">logistics stack</span>
        </motion.h1>
        <motion.p variants={fadeInUp} className="text-xl text-text-secondary leading-relaxed">
          Book a free 30-minute strategy call. We'll review your current setup and show you exactly what's possible with Helium.
        </motion.p>
      </motion.div>
    </section>
  );
}